export const buttonBgColor = getComputedStyle(
  document.documentElement
).getPropertyValue("--buttonBg");
export const whiteBgColor = getComputedStyle(
  document.documentElement
).getPropertyValue("--white");
export const blackTextColor = getComputedStyle(
  document.documentElement
).getPropertyValue("--blackText").trim() || "#3C3A42";
